import { useRef, useEffect, useCallback } from 'react';

export const useTimeout = (callback: (...args: []) => any, delay: number) => {
    const callbackRef = useRef(callback);
    const timeoutRef = useRef<any | null>(null);

    const set = useCallback(() => (timeoutRef.current = setTimeout(() => callbackRef.current(), delay)), []);

    const clear = useCallback(() => timeoutRef.current && clearTimeout(timeoutRef.current), []);

    const reset = useCallback(() => {
        clear();
        set();
    }, [clear, set]);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        set();
        return clear();
    }, [set, clear]);

    return { clear, reset };
};
